export enum DashboardContainerColorProps {
  WHITE = '#ffffff',
  GREY = '#f6f7fb',
  GREY_LIGHT = '#F7F7F7',
}
